"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var de_messages_json_1 = __importDefault(require("./langs/de.messages.json"));

var en_messages_json_1 = __importDefault(require("./langs/en.messages.json"));

var fr_messages_json_1 = __importDefault(require("./langs/fr.messages.json"));

var cs_messages_json_1 = __importDefault(require("./langs/cs.messages.json"));

var es_messages_json_1 = __importDefault(require("./langs/es.messages.json"));

var it_messages_json_1 = __importDefault(require("./langs/it.messages.json"));

var nl_messages_json_1 = __importDefault(require("./langs/nl.messages.json"));

var pl_messages_json_1 = __importDefault(require("./langs/pl.messages.json")); // There are not many strings, so doing a very basic translator here


var Translator =
/** @class */
function () {
  function Translator() {
    var _this = this;

    this.language = 'de';

    this.translate = function (key) {
      var translation = key;
      var translations = {
        de: de_messages_json_1.default,
        en: en_messages_json_1.default,
        fr: fr_messages_json_1.default,
        cs: cs_messages_json_1.default,
        es: es_messages_json_1.default,
        it: it_messages_json_1.default,
        nl: nl_messages_json_1.default,
        pl: pl_messages_json_1.default
      };

      if (translations[_this.language] && translations[_this.language][key]) {
        translation = translations[_this.language][key];
      }

      return translation;
    };
  }

  return Translator;
}();

exports.Translator = Translator;
exports.default = new Translator();